<ng-container *ngIf="isVisible">
	<span class="flex-shrink-0 align-self-center border-start ci-lock-separator"></span>
	<div class="d-flex align-items-center gap-2">
		<button
			type="button"
			class="btn btn-sm d-inline-flex align-items-center justify-content-center border bg-white px-2 ci-lock-icon-btn"
			[disabled]="!canToggleLock || unlockingOrder"
			tooltipStyleClass="custom-tooltip"
			[tooltipPosition]="tooltipPlacement"
			[pTooltip]="lockTooltip"
			(click)="onToggleLock()"
		>
			<i class="fa-regular ci-lock-icon--current" [ngClass]="currentIconClass"></i>
			<i *ngIf="canToggleLock" class="fa-regular ci-lock-icon--next" [ngClass]="nextIconClass"></i>
		</button>
		<div *ngIf="orderInboxModel.locked" class="d-flex flex-column align-items-start lh-sm">
			<span class="text-muted ci-locked-by-label">Locked by:</span>
			<span class="text-nowrap ci-locked-by-name">{{ lockedByDisplayName }}</span>
		</div>
	</div>
</ng-container>
